import { cn } from "@/lib/utils";

interface ShadowBoxProps {
  children: React.ReactNode;
  className?: string;
}

export function ShadowBox({ children, className }: ShadowBoxProps) {
  return <div className={cn("shadow-standard bg-white rounded-lg", className)}>{children}</div>;
}
